import LinesEllipsis from "react-lines-ellipsis";

import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import BookingCard from "examples/Cards/BookingCard";

// DigiHapi components
import Activity from "components/DigiHapi/Activity";
import ConfirmDialog from "components/DigiHapi/ConfirmDialog";
import MDWizard from "components/DigiHapi/MDWizard";
import Notification from "components/DigiHapi/Notification";
import PagePagination from "components/DigiHapi/PagePagination";

import {
	fetchGetOwnEvents,
	fetchAddEvent,
	fetchUpdateEvent,
	fetchPublishEvent,
	fetchGetEvent,
	fetchGetEventChannels,
	fetchDeleteEvent,
	fetchModeratingAccept,
	fetchModeratingRefuse
} from "actions/event";
import {
	RESET_EVENT,
	SET_POST_SORTED,
	EDITING,
	PUBLISHED,
	MODERATING,
	REFUSED,
	ROLE_WEBMASTER,
	ADD_WIZARD,
	CLEAR_SNACK_WARN_MSG
} from "actions/types";

import { Component, createRef, PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./Step7";

import canUseDOM from "can-use-dom";
import tentPlaceholder from "assets/img/tent_placeholder.png";

// Footer label of a post card, depending on its status
const STATUS_DISPLAY = {
	[EDITING]: { icon: "edit", label: "Brouillon", color: "info" },
	[MODERATING]: {
		icon: "remove_red_eye",
		label: "En cours de modération",
		color: "warning"
	},
	[REFUSED]: { icon: "report_problem", label: "Rejetée", color: "error" },
	[PUBLISHED]: { icon: "check", label: "Publiée", color: "success" }
};

const geolocation =
	canUseDOM && navigator.geolocation
		? navigator.geolocation
		: {
				getCurrentPosition(success, failure) {
					failure("Your browser doesn't support geolocation.");
				}
		  };

class PostsWizard extends Component {
	fetchAddEvent = () => {
		const {
			fetchAddEvent,
			title,
			description,
			url,
			startDate,
			files,
			lang,
			goodDealId,
			photoUri,
			eventTypeId,
			promotion
		} = this.props;

		fetchAddEvent({
			title,
			description,
			url,
			startDate: startDate ? startDate.toDate().getTime() : null,
			files,
			lang,
			goodDealId,
			photoUri,
			eventTypeId,
			promotion
		});
	};

	fetchUpdateEvent = () => {
		const {
			fetchUpdateEvent,
			_id,
			title,
			description,
			url,
			startDate,
			files,
			lang,
			goodDealId,
			photoUri,
			eventTypeId,
			promotion
		} = this.props;

		fetchUpdateEvent({
			_id,
			title,
			description,
			url,
			startDate: startDate ? startDate.toDate().getTime() : null,
			files,
			lang,
			goodDealId,
			photoUri,
			eventTypeId,
			promotion
		});
	};

	render() {
		const { update, isFetching, onClose } = this.props;
		return (
			<MDWizard
				onClose={onClose}
				isFetching={isFetching}
				validate
				steps={[
					{
						stepName: "Type",
						stepComponent: Step1,
						stepId: "link"
					},
					{
						stepName: "Illustration",
						stepComponent: Step2,
						stepId: "picture"
					},
					{
						stepName: "Français",
						stepComponent: Step3,
						stepId: "french"
					},
					{
						stepName: "Anglais",
						stepComponent: Step4,
						stepId: "english"
					}
				]}
				title={
					update
						? "Mise à jour d'une publication : "
						: "Ajout d'une publication"
				}
				finishButtonClick={update ? this.fetchUpdateEvent : this.fetchAddEvent}
				finishButtonText={update ? "Modifier" : "Ajouter"}
			/>
		);
	}
}

class PublishWizard extends Component {
	publishEvent = () => {
		const { fetchPublishEvent, _id: eventId, channelsIds } = this.props;
		fetchPublishEvent(eventId, channelsIds);
	};

	render() {
		const { isFetching, onClose } = this.props;
		return (
			<MDWizard
				onClose={onClose}
				isFetching={isFetching}
				validate
				steps={[
					{
						stepName: "HapiCity",
						stepComponent: Step5,
						stepId: "hapicity_channels"
					},
					{
						stepName: "O’Camping",
						stepComponent: Step6,
						stepId: "ocamping_channels"
					},
					{
						stepName: "HapiColibri",
						stepComponent: Step7,
						stepId: "hapicolibri_channels"
					}
				]}
				title={"Mise en ligne d'une publication"}
				finishButtonClick={this.publishEvent}
				finishButtonText={"Publier"}
			/>
		);
	}
}

class PostsPage extends PureComponent {
	state = {
		br: false,
		color: "info",
		message: null,
		wizard: null,
		eventToDelete: null,
		modeTable: false
	};

	constructor(props) {
		super(props);
		this.wizardRef = createRef();
		this.wizardPublishRef = createRef();
	}

	componentDidMount() {
		this.props.fetchGetOwnEvents();
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			dispatch,
			snackErrorMsg,
			snackWarnMsg,
			snackInfoMsg,
			newWizard,
			fetchGetOwnEvents,
			warnMsgCleared
		} = this.props;

		if (warnMsgCleared && !prevProps.warnMsgCleared) {
			dispatch({
				type: ADD_WIZARD
			});
		}
		if (
			(snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) ||
			(snackWarnMsg && prevProps.snackWarnMsg !== snackWarnMsg)
		) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetOwnEvents();
			this.autoCloseMessage();
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			if (newWizard === "publish") {
				this.addPublishWizard();
			} else {
				this.addWizard(newWizard === "update");
			}
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackWarnMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg
				? snackInfoMsg
				: snackWarnMsg
				? snackWarnMsg
				: snackErrorMsg,
			color: snackInfoMsg ? "info" : snackWarnMsg ? "warning" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	// Closing the warning snackbar redirects to the profile page
	closeNotification = () => {
		const { color } = this.state;
		this.setState({ br: false });
		if (color === "warning") {
			this.props.history.push("/team/profile");
		}
	};

	onClose = () => {
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_EVENT
		});
	};

	addWizard = (update = true) => {
		this.setState({
			wizard: (
				// wrap the React component in a standard DOM element and assign a ref to that
				// to scroll correctly
				<Grid
					item
					xs={12}
					ref={elt => {
						this.wizardRef = elt;
					}}
				>
					<ConnectedPostsWizard update={update} onClose={this.onClose} />
				</Grid>
			)
		});
	};

	addPublishWizard = eventId => {
		this.setState({
			wizard: (
				// wrap the React component in a standard DOM element and assign a ref to that
				// to scroll correctly
				<Grid
					item
					xs={12}
					ref={elt => {
						this.wizardPublishRef = elt;
					}}
				>
					<ConnectedPublishWizard eventId={eventId} onClose={this.onClose} />
				</Grid>
			)
		});
	};

	get2Chars = param => {
		return ("" + param).length === 1 ? "0" + param : param;
	};

	formatDate = d => {
		const date = new Date(d);
		return `${this.get2Chars(date.getDate())}/${this.get2Chars(
			date.getMonth() + 1
		)}/${date.getFullYear()} ${this.get2Chars(
			date.getHours()
		)}:${this.get2Chars(date.getMinutes())}`;
	};

	deleteEvent = id => {
		this.props.fetchDeleteEvent(id);
	};

	acceptEvent = id => {
		this.props.fetchModeratingAccept(id);
	};

	refuseEvent = id => {
		this.props.fetchModeratingRefuse(id);
	};

	// Actions available on a post, depending on its status and the user role
	getActions = status => {
		const { user } = this.props;
		const actions = [];

		if (status === EDITING || status === PUBLISHED) {
			actions.push({
				color: "success",
				icon: "send",
				onClick: this.editEventChannels,
				tooltip: "Publier"
			});
		}
		if (status === MODERATING && user.role === ROLE_WEBMASTER) {
			actions.push({
				color: "error",
				icon: "error",
				onClick: this.refuseEvent,
				tooltip: "Rejeter"
			});
		}
		if (status === MODERATING && user.role === ROLE_WEBMASTER) {
			actions.push({
				color: "success",
				icon: "check_circle",
				onClick: this.acceptEvent,
				tooltip: "Accepter"
			});
		}
		if (status !== MODERATING || user.role === ROLE_WEBMASTER) {
			actions.push({
				color: "info",
				icon: "edit",
				onClick: this.editEvent,
				tooltip: "Modifier"
			});
		}
		actions.push({
			color: "error",
			icon: "delete",
			onClick: this.delete,
			tooltip: "Supprimer"
		});
		return actions;
	};

	// Table actions are disabled while a wizard is open; card actions are not (as before)
	renderActions = (id, status, variant = "text") =>
		this.getActions(status).map(action => (
			<Tooltip key={action.tooltip} title={action.tooltip} placement="bottom">
				<span>
					<MDButton
						variant={variant}
						color={action.color}
						size="small"
						iconOnly
						circular={variant !== "text"}
						disabled={variant !== "text" && !!this.state.wizard}
						onClick={() => action.onClick(id)}
						sx={{ mx: 0.25 }}
					>
						<Icon>{action.icon}</Icon>
					</MDButton>
				</span>
			</Tooltip>
		));

	getStrStatus = status => {
		switch (status) {
			case MODERATING:
				return "En cours de modération";

			case PUBLISHED:
				return "Publiée";

			case REFUSED:
				return "Rejetée";

			default:
				return "Brouillon";
		}
	};

	getEventsData = () => {
		const { events } = this.props;

		const ownEvents = events.map(
			({ _id, dateUpdated, description, title, status }) => {
				return {
					dateUpdated: this.formatDate(dateUpdated),
					description: (
						<MDBox sx={{ whiteSpace: "pre-wrap" }}>
							<LinesEllipsis text={description} />
						</MDBox>
					),
					title,
					status: this.getStrStatus(status),
					actions: (
						<MDBox display="flex" justifyContent="flex-end">
							{this.renderActions(_id, status, "gradient")}
						</MDBox>
					)
				};
			}
		);
		return ownEvents;
	};

	delete = eventId => {
		this.setState({ eventToDelete: eventId });
	};

	editEvent = id => {
		this.props.fetchGetEvent(id);
	};

	editEventChannels = id => {
		this.props.fetchGetEventChannels(id);
	};

	changeCurrentPage = page => {
		const { fetchGetOwnEvents, limit, sorted } = this.props;
		fetchGetOwnEvents(page, limit, sorted);
	};

	renderCard = event => {
		const { wizard } = this.state;
		const status = STATUS_DISPLAY[event.status];
		const image = event.photoUri || tentPlaceholder;
		const title = event.title
			? event.title
			: `Publication du ${this.formatDate(event.dateUpdated)}`;
		return (
			<Grid item key={event._id} xs={12} md={4}>
				<MDBox pt={3} height="100%">
					<BookingCard
						image={image}
						title={title}
						description={
							<MDBox minHeight="60px" sx={{ whiteSpace: "pre-wrap" }}>
								<a
									href={`https://app.ocamping.fr/event?id=${event._id}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									<MDTypography
										variant="button"
										color="info"
										fontWeight="medium"
									>
										Voir la publication
									</MDTypography>
								</a>
								<LinesEllipsis
									text={event.description}
									maxLine={3}
									trimRight
									basedOn="letters"
								/>
							</MDBox>
						}
						location={
							status ? (
								<MDBox display="flex" alignItems="center" color={status.color}>
									<Icon color="inherit" sx={{ m: 0.5 }}>
										{status.icon}
									</Icon>
									<MDTypography
										variant="button"
										fontWeight="regular"
										color={status.color}
									>
										{status.label}
									</MDTypography>
								</MDBox>
							) : null
						}
						action={
							<MDBox>{this.renderActions(event._id, event.status)}</MDBox>
						}
						disableHover={!!wizard}
					/>
				</MDBox>
			</Grid>
		);
	};

	renderAddButtons = toggleLabel => {
		const { dispatch } = this.props;
		const { modeTable, wizard } = this.state;
		return (
			<MDBox display="flex" flexWrap="wrap" justifyContent="flex-end" gap={1}>
				<MDButton
					variant="outlined"
					color="secondary"
					onClick={() => this.setState({ modeTable: !modeTable })}
					disabled={modeTable && !!wizard}
				>
					<Icon>{modeTable ? "view_module" : "table_rows"}</Icon>
					&nbsp;{toggleLabel}
				</MDButton>
				<MDButton
					variant="gradient"
					color="primary"
					onClick={() =>
						dispatch({
							type: CLEAR_SNACK_WARN_MSG
						})
					}
					disabled={modeTable && !!wizard}
				>
					<Icon>playlist_add</Icon>
					&nbsp;{"Ajout d'une publication"}
				</MDButton>
			</MDBox>
		);
	};

	render() {
		const { color, message, wizard, modeTable, eventToDelete, br } = this.state;
		const {
			dispatch,
			isFetchingList,
			page,
			totalPages,
			limit,
			sorted,
			fetchGetOwnEvents,
			events
		} = this.props;

		// In table mode the table shows its own loading bar: replacing the page with
		// the loader would unmount the table, whose mount triggers a new fetch (loop)
		return isFetchingList && !modeTable ? (
			<Activity />
		) : (
			<Grid container spacing={3}>
				{!modeTable && (
					<>
						{events.map(this.renderCard)}
						{!wizard && (
							<Grid item xs={12}>
								<MDBox
									display="flex"
									flexWrap="wrap"
									justifyContent="space-between"
									alignItems="center"
									gap={2}
								>
									<PagePagination
										currentPage={page}
										totalPages={totalPages}
										changeCurrentPage={this.changeCurrentPage}
									/>
									<MDBox ml="auto">{this.renderAddButtons("Tableau")}</MDBox>
								</MDBox>
							</Grid>
						)}
					</>
				)}
				{modeTable && (
					<Grid item xs={12}>
						<Card>
							<MDBox
								mx={2}
								mt={-3}
								py={2}
								px={2}
								variant="gradient"
								bgColor="primary"
								borderRadius="lg"
								coloredShadow="primary"
								display="flex"
								alignItems="center"
								color="white"
							>
								<Icon fontSize="medium">playlist_add</Icon>
								<MDTypography variant="h6" color="white" ml={1.5}>
									Publications
								</MDTypography>
							</MDBox>
							<MDBox p={2}>
								<DataTable
									data={this.getEventsData()}
									filterable
									columns={[
										{
											Header: "Date",
											accessor: "dateUpdated",
											sortable: true,
											filterable: false
										},
										{
											Header: "Titre",
											accessor: "title",
											sortable: true,
											filterable: false
										},
										{
											Header: "Description",
											accessor: "description",
											sortable: false,
											filterable: false
										},
										{
											Header: "Statut",
											accessor: "status",
											sortable: true,
											filterable: false
										},
										{
											Header: "Actions",
											accessor: "actions",
											sortable: false,
											filterable: false
										}
									]}
									loading={isFetchingList}
									manual
									onFetchData={(state, instance) => {
										dispatch({
											type: SET_POST_SORTED,
											value: state.sorted
										});
										fetchGetOwnEvents(
											state.page + 1,
											state.pageSize,
											state.sorted
										);
									}}
									page={page - 1}
									defaultPageSize={limit}
									defaultSorted={sorted}
									pageSizeOptions={[3, 6, 9, 18, 36, 72]}
									pages={totalPages}
									showPaginationTop
									showPaginationBottom={false}
									previousText="Précédent"
									nextText="Suivant"
									rowsText="Lignes"
									noDataText="Aucunes publications"
									ofText="sur"
									loadingText="Chargement..."
								/>
							</MDBox>
							<MDBox p={2}>{this.renderAddButtons("Fiches")}</MDBox>
						</Card>
					</Grid>
				)}
				{wizard}
				<ConfirmDialog
					open={!!eventToDelete}
					message="Êtes-vous sûr de vouloir supprimer la publication ?"
					confirmText="Supprimer"
					onCancel={() => this.setState({ eventToDelete: null })}
					onConfirm={() => {
						this.deleteEvent(eventToDelete);
						this.setState({ eventToDelete: null });
					}}
				/>
				{color === "warning" ? (
					// Warnings stay open until closed (closing redirects to the profile)
					<MDSnackbar
						color="warning"
						icon={<Icon>warning</Icon>}
						title="Attention"
						content={message || ""}
						dateTime=""
						open={br}
						close={this.closeNotification}
					/>
				) : (
					<Notification
						color={color}
						message={message}
						open={br}
						onClose={this.closeNotification}
					/>
				)}
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		title,
		description,
		url,
		startDate,
		files,
		lang,
		photoUri,
		campsitesIds,
		citiesIds,
		snackErrorMsg,
		snackWarnMsg,
		snackInfoMsg,
		events,
		goodDealId,
		isFetching,
		isFetchingList,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		newWizard,
		eventTypeId,
		promotion,
		warnMsgCleared,
		channelsIds
	} = state.eventReducer;

	const { user } = state.profileReducer;

	return {
		isFetching,
		_id,
		title,
		description,
		url,
		startDate,
		files,
		lang,
		photoUri,
		campsitesIds,
		citiesIds,
		snackErrorMsg,
		snackWarnMsg,
		snackInfoMsg,
		events: Object.values(events),
		isFetchingList,
		goodDealId,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		newWizard,
		user,
		eventTypeId,
		promotion,
		warnMsgCleared,
		channelsIds
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetOwnEvents,
			fetchAddEvent,
			fetchGetEventChannels,
			fetchUpdateEvent,
			fetchPublishEvent,
			fetchModeratingAccept,
			fetchModeratingRefuse,
			fetchGetEvent,
			fetchDeleteEvent
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedPostsWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(PostsWizard);
const ConnectedPublishWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(PublishWizard);

export default {
	PostsPage: connect(mapStateToProps, mapDispatchToProps)(PostsPage),
	PostsWizard: ConnectedPostsWizard,
	PublishWizard: ConnectedPublishWizard
};
